var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { OptionItem } from '../../../../diagram/utils/option-item';
import * as _ from 'lodash';
import { RelationType } from './relation-type';
var LogicTypeOptionService = /** @class */ (function () {
    function LogicTypeOptionService() {
        this.optionList = [
            new OptionItem(RelationType.And, 'AND'),
            new OptionItem(RelationType.Or, 'OR')
        ];
    }
    LogicTypeOptionService.prototype.getOptions = function () {
        return this.optionList;
    };
    LogicTypeOptionService.prototype.getOptionNameByKey = function (key) {
        var option = _.find(this.optionList, function (s) { return s.key === Number(key); });
        return option ? option.name : '';
    };
    LogicTypeOptionService = __decorate([
        Injectable()
    ], LogicTypeOptionService);
    return LogicTypeOptionService;
}());
export { LogicTypeOptionService };
